import { FormEvent, useRef, useState } from 'react';
import { FaCircleStop } from 'react-icons/fa6';
import { useQuestionContext } from '../../../context/chatbot/QuestionContextApi';
import { useTranslation } from 'react-i18next';
import Input from '../Input';
import ChatbotLocalIcon from '../../../ui/ChatbotLocalIcon';
import styled from 'styled-components';
import { languageDirection } from '../../../i18n';

const ButtonIcon = styled.button`
  background: none !important;
  border: none !important;
  position: absolute;
  bottom: 1.75rem;
  height: 3rem;
  width: 3rem;
  ${(props) =>
    props.theme.direction === 'rtl' ? 'left: 0.25rem' : 'right: 0.25rem'};

  & > img {
    margin: auto;
  }
`;

function Search() {
  const [inputMessage, setInputMessage] = useState('');
  const { t } = useTranslation('chatbot');

  const questionContext = useQuestionContext();
  if (!questionContext) {
    throw new Error('There is no question context');
  }

  const side = languageDirection() === 'rtl' ? 'left' : 'right';

  const {
    setQuestion,
    question: { isLoading },
    pauseMessage,
  } = questionContext;
  const pageRef = useRef(null);

  const submitHandler = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (inputMessage !== '') {
      setQuestion({
        isLoading: true,
        content: inputMessage,
        streamAnswer: '',
      });
      setInputMessage('');
    }
  };

  const handleStopConversation = (e: any) => {
    e.preventDefault();
    pauseMessage(t('pauseResponse'));
  };

  return (
    <div className="w-full">
      <form onSubmit={submitHandler} className="relative">
        <ButtonIcon side={side}>
          {isLoading ? (
            // @ts-expect-error jsx error
            <FaCircleStop
              className="h-[1.5rem] w-[1.5rem] m-1"
              onClick={handleStopConversation}
            />
          ) : (
            <ChatbotLocalIcon
              iconName="/assets/icons/arrow-left.svg"
              style={
                languageDirection() === 'ltr'
                  ? { transform: 'rotate(180deg)' }
                  : {}
              }
            />
          )}
        </ButtonIcon>
        <Input
          onInputMessage={setInputMessage}
          inputMessage={inputMessage}
          ref={pageRef}
        />
      </form>
    </div>
  );
}

export default Search;
